export default function About() {
  return (
    <section id="about" className="py-20 lg:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/e1acdab38e84ea67e434886d958619ae.jpg" 
                alt="African Business District" 
                className="w-full h-full object-cover object-center"
              />
            </div>
            
            <div className="absolute top-8 left-8 space-y-3">
              <div className="bg-white/95 backdrop-blur-md px-6 py-3 rounded-full shadow-lg">
                <div className="text-sm font-bold text-gray-900">10+ Years Experience</div>
              </div>
              <div className="bg-white/95 backdrop-blur-md px-6 py-3 rounded-full shadow-lg">
                <div className="text-sm font-bold text-gray-900">500+ Clients Served</div>
              </div>
              <div className="bg-white/95 backdrop-blur-md px-6 py-3 rounded-full shadow-lg">
                <div className="text-sm font-bold text-gray-900">Pan-African Reach</div>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-block bg-[#D4AF37] text-white px-4 py-1.5 rounded-full text-xs font-semibold tracking-wide">
                WHO WE ARE
              </div>
              <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Your Trusted Partner<br />
                <span className="text-[#D4AF37]">in Business Growth</span>
              </h2>
              <div className="flex flex-wrap gap-3">
                <span className="border-2 border-gray-300 text-gray-700 px-4 py-2 rounded-full text-sm font-medium">Consulting</span>
                <span className="text-gray-700 px-4 py-2 text-sm font-medium">Research</span>
                <span className="text-gray-700 px-4 py-2 text-sm font-medium">Recruitment</span>
                <span className="text-gray-700 px-4 py-2 text-sm font-medium">Security</span>
              </div>
            </div>

            <div className="bg-[#1A1A1A] rounded-3xl p-8 lg:p-10">
              <div className="grid lg:grid-cols-2 gap-8 items-center">
                <div className="space-y-4">
                  <div className="text-[#D4AF37] text-xs font-bold tracking-wide">ABOUT US</div>
                  <p className="text-white text-base leading-relaxed">
                    ACE Consultancy Africa is a premier business solutions provider dedicated to empowering African enterprises. We combine local market expertise with international best practices to deliver exceptional results across multiple service domains.
                  </p>
                  <p className="text-white/80 text-sm leading-relaxed">
                    From home security consulting to market research, asset sales, grant writing, and recruitment services, we provide comprehensive solutions tailored to the unique challenges and opportunities of the African business landscape.
                  </p>
                </div>
                <div className="rounded-2xl overflow-hidden h-64">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Diverse%20African%20business%20team%20collaborating%20around%20a%20conference%20table%2C%20professionals%20engaged%20in%20strategic%20planning%20meeting%2C%20modern%20office%20interior%20with%20natural%20light%2C%20teamwork%20and%20collaboration%20in%20corporate%20setting%2C%20professional%20business%20consultation%20atmosphere%20with%20documents%20and%20laptops&width=600&height=600&seq=ace-about-team-001&orientation=squarish" 
                    alt="Team Collaboration" 
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
